import { useQuery } from '@tanstack/react-query';
import { CommonApi } from '../../../shared/api/common/common.api';

export const usePageInstructionsQuery = () => useQuery({
    queryKey: ['page-instructions'],
    queryFn: () => CommonApi.pageInstructions().then((response) => response.data.data)
});
